<script setup lang="ts">
import { computed, shallowRef, watchEffect } from 'vue'
import type { IStepperSeperatorProps, TProgressStepsOrientation, TProgressStepsSizes } from '../types'
import { useStepperSeperatorConfig } from './composables/useStepperSeperatorConfig'

const props = defineProps<IStepperSeperatorProps>()

type TLineCoordinates = Record<'x1' | 'y1' | 'x2' | 'y2', number | `${number}%`>

const coordinates: Record<TProgressStepsSizes, Record<TProgressStepsOrientation, TLineCoordinates>> = {
    SMALL: {
        horizontal: {
            x1: 0,
            y1: 2,
            x2: '100%',
            y2: 2,
        },
        vertical: {
            x1: 2,
            y1: 0,
            x2: 2,
            y2: '100%',
        },
    },
    MEDIUM: {
        horizontal: {
            x1: 2,
            y1: 2,
            x2: '100%',
            y2: 2,
        },
        vertical: {
            x1: 2,
            y1: 2,
            x2: 2,
            y2: '100%',
        },
    },
}
const currentCoordinates = computed(() => coordinates[props.size][props.orientation])

const stepperSeperatorConfig = shallowRef(useStepperSeperatorConfig(props))

watchEffect(() => {
    stepperSeperatorConfig.value = useStepperSeperatorConfig(props)
})
</script>

<template>
    <div :class="stepperSeperatorConfig.root">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="4"
            width="4"
            fill="none"
            :class="stepperSeperatorConfig.SVG"
        >
            <line
                :x1="currentCoordinates.x1"
                :y1="currentCoordinates.y1"
                :x2="currentCoordinates.x2"
                :y2="currentCoordinates.y2"
                class="stroke-brand-accent-invert pointer-events-none"
                :stroke-height="props.size === 'MEDIUM' ? 2 : 1"
                :stroke-width="props.size === 'MEDIUM' ? 2 : 1"
                stroke-miterlimit="16"
                stroke-linecap="round"
                :stroke-dasharray="props.size === 'MEDIUM' ? '0 8' : '0'"
            />
        </svg>
    </div>
</template>
